import {Action} from '@ngrx/store';

export const LOADING = '[ResidentStatistics] Loading';

export class Loading implements Action {
	readonly type = LOADING;
}

export type Actions = Loading;
